const reportType = {
	name: 'Report Type | Report Types',
}

export default reportType
